export default __webpack_public_path__ + "static/media/sy-dp4.eb27f423.png";